export default "__VITE_ASSET__jEDcdFO$__"